import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import SupplierAuth from "@/pages/SupplierAuth";
import InviteAccess from "@/pages/InviteAccess";
import ESGQuestionnaire from "@/pages/ESGQuestionnaire";
import SubmissionConfirmation from "@/pages/SubmissionConfirmation";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSupplierDetail from "@/pages/AdminSupplierDetail";

function App() {
  return (
    <div className="App min-h-screen">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<SupplierAuth />} />
          <Route path="/invite/:token" element={<InviteAccess />} />
          <Route path="/questionnaire" element={<ESGQuestionnaire />} />
          <Route path="/submitted" element={<SubmissionConfirmation />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/supplier/:supplierId" element={<AdminSupplierDetail />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
